import { render } from "./BenefitAccordion.vue?vue&type=template&id=2e625f16&scoped=true"
import script from "./BenefitAccordion.vue?vue&type=script&lang=js"
export * from "./BenefitAccordion.vue?vue&type=script&lang=js"

import "./BenefitAccordion.vue?vue&type=style&index=0&id=2e625f16&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e625f16"]])

export default __exports__